(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["p4h-colour-launch-banner"] && !Shopify.designMode) return;
  try {
    
const placeColourLaunchBanner = () => {
  const banner = document.querySelector('.p4h-colour-banner');
  const masthead = document.querySelector('.collection--section .productgrid--masthead');
  if (!banner || !masthead) return;
  let stack = masthead.parentElement;
  if (!stack.classList.contains('p4h-launch-masthead-stack')) {
    stack = document.createElement('div');
    stack.className = 'p4h-launch-masthead-stack';
    masthead.before(stack);
    stack.append(masthead);
  }
  if (banner.parentElement !== stack) stack.append(banner);
};
placeColourLaunchBanner();
document.addEventListener('shopify:section:load', placeColourLaunchBanner);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["p4h-colour-pilot"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialized = new WeakSet();

    const initialize = (root) => {
      if (initialized.has(root)) return;
      initialized.add(root);

      let observer;
      let expiry;

      const stop = () => {
        observer?.disconnect();
        clearTimeout(expiry);
      };

      const collapse = () => {
        if (root.dataset.p4hCollapseInitialized === 'true') {
          stop();
          return true;
        }

        const widget = root.querySelector('[data-bundle-pp-id][data-layout="accordion"]');
        if (!widget) return false;

        const headers = Array.from(widget.querySelectorAll('.bogos-bundle-pp-step > .bogos-bundle-pp-step-header'));
        if (headers.length !== 6) return false;

        root.dataset.p4hCollapseInitialized = 'true';
        stop();

        headers.forEach((header) => {
          if (header.getAttribute('aria-expanded') === 'true') header.click();
        });

        return true;
      };

      if (collapse()) return;

      observer = new MutationObserver(collapse);
      observer.observe(root, { childList: true, subtree: true });
      expiry = setTimeout(() => observer.disconnect(), 30000);
    };

    const initializeAll = () => {
      document.querySelectorAll('.p4h-colour-pilot__app').forEach(initialize);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initializeAll, { once: true });
    } else {
      initializeAll();
    }

    document.addEventListener('shopify:section:load', initializeAll);
  })();

  } catch(e) { console.error(e); }
})();
})();
